import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  background-color: var(--tts-blue);
  background-color: ${props =>
    (props.backgroundColour === 'red' && 'var(--tts-red)') ||
    (props.backgroundColour === 'blue' && 'var(--tts-blue)') ||
    (props.backgroundColour === 'yellow' && 'var(--tts-mustard)') ||
    (props.backgroundColour === 'pink' && 'var(--tts-pink)') ||
    (props.backgroundColour === 'white' && 'var(--tts-white)') ||
    (props.backgroundColour === 'black' && 'var(--oh-black)')};
  color: ${props =>
    ((props.backgroundColour === 'red' ||
      props.backgroundColour === 'blue' ||
      props.backgroundColour === 'black' ||
      props.backgroundColour === 'pink') &&
      'var(--tts-white)') ||
    (props.backgroundColour === 'yellow' && 'var(--tts-black)') ||
    (props.backgroundColour === 'white' && 'var(--oh-black)')};
  line-height: 1.3;
  white-space: nowrap;
  border: none;
  border-radius: 3px;
  padding: 10px 18px;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: var(--bold-font-weight);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${props =>
      (props.backgroundColour === 'red' && 'var(--tts-pink)') ||
      (props.backgroundColour === 'blue' && 'var(--tts-purple)') ||
      (props.backgroundColour === 'yellow' && 'var(--tts-yellow)') ||
      (props.backgroundColour === 'pink' && 'var(--tts-red)') ||
      (props.backgroundColour === 'black' && 'var(--tts-white)') ||
      (props.backgroundColour === 'white' && 'var(--oh-black)')};
    color: ${props =>
      (props.backgroundColour === 'red' && 'var(--tts-black)') ||
      (props.backgroundColour === 'pink' && 'var(--tts-white)') ||
      (props.backgroundColour === 'white' && 'var(--tts-white)') ||
      (props.backgroundColour === 'black' && 'var(--oh-black)')};
  }

  &:focus {
    outline: 2px solid var(--tts-black);
  }

  &:disabled {
    pointer-events: none;
    background-color: var(--button-disabled-color);
  }
`;

export type ButtonColour = 'red' | 'blue' | 'yellow' | 'pink' | 'white' | 'black';

export interface ButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  backgroundColour: ButtonColour;
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
  type?: 'submit' | 'button';
}

export default function Button({
  backgroundColour,
  children,
  onClick,
  className,
  type,
  ...restProps
}: ButtonProps) {
  return (
    <StyledButton
      backgroundColour={backgroundColour}
      className={className}
      onClick={onClick}
      type={type === 'submit' ? 'submit' : 'button'}
      {...restProps}
    >
      {children}
    </StyledButton>
  );
}
